import { useState, useEffect } from 'react';

/**
 * useLogoStyle Hook
 * Fetches broadcast settings from the API
 * Used by Vision Master overlays to apply styling
 *
 * @returns {Object} { logoStyle, scoreboardSettings, broadcasterLogo, broadcasterLogoPosition, loading, error }
 */
export const useLogoStyle = () => {
  const [logoStyle, setLogoStyle] = useState(null);
  const [scoreboardSettings, setScoreboardSettings] = useState(null);
  const [broadcasterLogo, setBroadcasterLogo] = useState(null);
  const [broadcasterLogoPosition, setBroadcasterLogoPosition] = useState('top-right');
  const [overlayResolution, setOverlayResolution] = useState({ width: 1920, height: 1080, preset: 'fullhd' });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_API_URL || `http://${window.location.hostname}:5000`}/api/settings/broadcast`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (!response.ok) {
          throw new Error('Failed to fetch broadcast settings');
        }

        const data = await response.json();
        setLogoStyle({
          backgroundStyle: data.logo_background_style,
          backgroundColor: data.logo_background_color
        });
        setScoreboardSettings({
          backgroundColor: data.scoreboard_bg_color || '#000000',
          textColor: data.scoreboard_text_color || '#FFFFFF',
          alignment: data.scoreboard_alignment || 'center'
        });
        setBroadcasterLogo(data.broadcaster_logo_url || null);
        setBroadcasterLogoPosition(data.broadcaster_logo_position || 'top-right');
        setOverlayResolution({
          width: data.overlay_width || 1920,
          height: data.overlay_height || 1080,
          preset: data.overlay_preset || 'fullhd'
        });
      } catch (err) {
        console.error('Error fetching broadcast settings:', err);
        setError(err.message);
        // Fallback to defaults
        setLogoStyle({
          backgroundStyle: 'dark',
          backgroundColor: '#1F2937'
        });
        setScoreboardSettings({
          backgroundColor: '#000000',
          textColor: '#FFFFFF',
          alignment: 'center'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { logoStyle, scoreboardSettings, broadcasterLogo, broadcasterLogoPosition, overlayResolution, loading, error };
};
